// The prompt Marko pastes into Claude/Cowork together with his Apple Notes log.
// It produces the JSON the in-app importer ingests. Catalog names are injected so
// the LLM matches exercises to the app's catalog rather than inventing new ones.

import { EXERCISES } from '../../seed/exercises';

const CATALOG = EXERCISES.map((e) => `- ${e.name} (${e.weightEntry === 'per_side' ? 'per-hand dumbbell' : 'total kg'}${e.bodyweight ? ', bodyweight + added' : ''})`).join('\n');

export const IMPORT_PROMPT = `You convert my Apple Notes gym log into structured JSON for my tracker. Output ONLY a single JSON object, no prose.

Rules:
- Weights are stored as TOTAL kg. For dumbbell exercises I write the PER-HAND weight in my notes, so DOUBLE it (e.g. "20kg incline DB press" -> weightKg: 40). For machines/barbells/cables use the number as-is.
- For bodyweight movements (dips, Nordic curls, leg raises) weightKg is the ADDED external load only (0 if none, e.g. "+6kg" -> 6).
- rir: 0 means taken to failure, 1 = one rep in reserve, 2 = two. Warm-up/ramp sets: set "warmup": true and omit rir.
- Match each exercise to one of my catalog names below. If something has no match, keep it but use its raw name in "exercise" (I will be warned and can fix it). Do NOT invent weights or reps that are not in my notes.
- elbowFeel / forearmFeel: one of "none", "aware", "pain" if I noted it, else omit. grip: "supinated" | "hammer" | "neutral" etc. if noted.

My catalog:
${CATALOG}

JSON shape:
{
  "sessions": [
    {
      "date": "2026-05-30",
      "routine": "Upper A (push + back)",
      "bodyweightKg": 80.5,
      "note": "optional",
      "exercises": [
        {
          "exercise": "Dips (weighted)",
          "elbowFeel": "none",
          "sets": [
            { "weightKg": 6, "reps": 10, "rir": 0 },
            { "weightKg": 6, "reps": 8, "rir": 0 }
          ]
        }
      ]
    }
  ]
}

Here is my log:
<paste your Apple Notes text here>`;
